import {Directive} from '@angular/core';
import {RequiredRule} from '../../rules/rules';
import {BaseValidatorDirective} from './base-validator.directive';
import {NG_VALIDATORS} from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModel][isRequired]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: RequiredValidatorDirective,
            multi: true,
        }
    ],
})
export class RequiredValidatorDirective extends BaseValidatorDirective<RequiredRule> {
    public constructor() {
        super();
        this.rule = new RequiredRule();
    }
}
